module.exports = __webpack_public_path__ + "img/xiongan03.cda42a51.png";